import React from 'react';
import { VStack, HStack, Image, Text, Input, Button, Field as ChakraField } from '@chakra-ui/react';
import { Formik, Form, Field } from 'formik';
import axios from 'axios';
import * as Sentry from '@sentry/react';
import theme from '../theme';

export default () => {
	const [loginError, setLoginError] = React.useState('');

	return (
		<VStack bg={theme.colors.blue[700]} w="100%" h="100%" justify="center" align="center" overflow="hidden">
			<VStack p="80px" spacing={4} w="30%" minW="480px" bg={theme.colors.blue[800]}>
				<Image src="/themes/custom/msiforms/images/msi-logo.png" />
				<Formik
					initialValues={{
						username: localStorage.getItem('username') || '',
						password: ''
					}}
					onSubmit={({ username: name, password: pass }, actions) => {
						if (name && pass) {
							axios
								.post('/user/login?_format=json', {
									name,
									pass
								})
								.then(response => {
									const { data } = response;

									Sentry.setUser({
										id: data.current_user.id,
										username: data.current_user.name
									});

									if (data.access_token) {
										localStorage.setItem('username', name);
										localStorage.setItem('uid', data.current_user.uid);
										localStorage.setItem('isLoggedIn', true);
										location.reload();
									} else {
										setLoginError('Could not validate session response data');
									}
								})
								.catch(error => {
									if (error.response?.status !== 403) {
										localStorage.setItem('isLoggedIn', false);
										Sentry.captureException(error);
									}

									setLoginError(
										`${error.response?.status} ${error.response?.data?.message}` ??
											'A server error has occurred during login.'
									);
								})
								.finally(() => actions.setSubmitting(false));
						}
					}}
				>
					{props => (
						<>
							<Form>
								<VStack spacing={4}>
									<HStack w="100%">
										<Field name="username">
											{({ field }) => (
												<ChakraField.Root>
													<Input
														{...field}
														id="username"
														bg={theme.colors.white}
														placeholder="Username"
													/>
												</ChakraField.Root>
											)}
										</Field>
										<Text color={theme.colors.white}>@msimarinesolutions.com</Text>
									</HStack>
									<Field name="password">
										{({ field }) => (
											<ChakraField.Root>
												<Input
													{...field}
													id="password"
													type="password"
													w="100%"
													bg={theme.colors.white}
													placeholder="Password"
												/>
											</ChakraField.Root>
										)}
									</Field>
									<Button
										type="submit"
										color={theme.colors.white}
										bg={theme.colors.blue[700]}
										_hover={{ backgroundColor: theme.colors.blue[800] }}
										w="100%"
										isLoading={props.isSubmitting}
									>
										Sign In
									</Button>
								</VStack>
							</Form>
						</>
					)}
				</Formik>
				{loginError ? (
					<Text color={theme.colors.white} fontWeight="bold">
						{loginError}
					</Text>
				) : null}
			</VStack>
		</VStack>
	);
};
